import React from "react";
import Form from "react-bootstrap/Form";
import Col from "react-bootstrap/Col";
import {getPlaceholder,checkInvalid,getTextBoxClasses,getWidgetClasses,getFieldContentClasses,getFieldContentStyle,getVisibility,getTooltip, getMaxlength} from "../ParentWidgetFunc";

function TextAreaWidget(props){
  let conf = props.conf;
  let screenConf = props.screenConf;
    let textAreaControl = (
      <React.Fragment>
        <Form.Control
          placeholder={getPlaceholder(conf)}
          size={screenConf.horizontalForm ? "" : "sm"}
          autoComplete={conf.AutoCompleteForTextBox}
          disabled={!conf.Enabled}
          readOnly={conf.ReadOnly}
          as="textarea"
          className={getTextBoxClasses(conf)}
          name={conf.name}
          value={props.values[conf.name]}
          onChange={props.onChange}
          onBlur={props.onBlur}
          isInvalid={checkInvalid(props,conf)}
          data-testid={conf.name}
          maxLength={conf.checkMaxLength && getMaxlength(conf)}
        />
        <Form.Control.Feedback type="invalid" aria-live="polite" role="alert">
          {props.errors[conf.name]}
        </Form.Control.Feedback>
      </React.Fragment>
    );

    return (
      <Form.Group
        className={
          getWidgetClasses(conf,screenConf).join(" ") + " d-flex align-items-end"
        }
        controlId={conf.name}
		title={getTooltip(conf)}
		role="tooltip"
      >
        <div
          className={getFieldContentClasses(screenConf).join(" ")}
          style={getFieldContentStyle(conf)}
        >
          <Form.Label
            className={screenConf.horizontalForm ? "pt-1" : ""}
            style={getVisibility(conf,screenConf)}
          >
            {conf.Label}
          </Form.Label>
          {screenConf.horizontalForm ? (
            <Col>{textAreaControl}</Col>
          ) : (
            <React.Fragment> {textAreaControl}</React.Fragment>
          )}
        </div>
      </Form.Group>
    );
  
}

export default TextAreaWidget;
